import React, { useCallback, useEffect } from "react";
import StepLoading from "../StepLoading";
import { useDataFormContext } from "@/context/FormDataContext";
import { cleanNonDigits } from "@/libs/utils";
import { sanitizeCnpj } from "@consorciei/utils/cnpj";
import { IValidate, validate } from "@/services/lead";

interface IValidateResponse {
  status: boolean;
  message: "Lead data is valid" | "Lead data is invalid";
}

const PartnerUseExternalAPI = (): React.JSX.Element => {
  const { dataForm, currentAdm, setCurrentFormStep, setCurrentFormVariation } =
    useDataFormContext();

  const requestValidate = useCallback(async () => {
    const payload: IValidate = {
      group: dataForm.group as string,
      share: dataForm.share as string,
      documentNumber: dataForm.isPj
        ? sanitizeCnpj(dataForm.cnpj || "")
        : cleanNonDigits(dataForm.cpf as string),
      admId: currentAdm.id as string,
      registrationId: dataForm.registrationId as string,
    };

    try {
      const response = await validate(payload);
      const responseData = response.data as unknown as IValidateResponse;

      if (
        responseData.status &&
        responseData.message === "Lead data is valid"
      ) {
        setCurrentFormStep(2);
      } else if (
        responseData.status &&
        responseData.message === "Lead data is invalid"
      ) {
        setCurrentFormStep(6);
      } else {
        setCurrentFormStep(7);
      }
    } catch (error) {
      setCurrentFormStep(0);
      setCurrentFormVariation("all");
    }
  }, []);

  useEffect(() => {
    requestValidate();
  }, []);

  return (
    <StepLoading text={`Validando seus dados junto à ${currentAdm.name}...`} />
  );
};

export default PartnerUseExternalAPI;
